import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { templatesApi, Template } from "../api";

interface TemplatesState {
  templates: Template[];
  loading: boolean;
}

const initialState: TemplatesState = {
  templates: [],
  loading: false,
};

export const fetchTemplates = createAsyncThunk(
  "templates/fetch",
  async () => {
    const { data } = await templatesApi.getMy();
    return data;
  }
);

export const templatesSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTemplates.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.templates = action.payload;
        state.loading = false;
      });
  },
});
